import { h, render, Component } from 'preact'
import PropTypes from 'prop-types'
import axios from 'axios'

class SearchApp extends Component {
  constructor (props) {
    super(props)

    this.state = {
      itemsLender: [],
      itemsPage: [],
      queryString: '',
      isOpen: false
    }

    this.getItems = this.getItems.bind(this)
    this.inputHandler = this.inputHandler.bind(this)
    this.addEventListeners = this.addEventListeners.bind(this)
    this.removeEventListeners = this.removeEventListeners.bind(this)
    this.updateItems = this.updateItems.bind(this)
    this.detectClickOutside = this.detectClickOutside.bind(this)
  }

  inputHandler (e) {
    this.setState(
      {
        queryString: e.target.value
      },
      () => {
        if (this.state.queryString.length >= 3) {
          this.getItems()
        } else {
          this.clearItems()
        }
      }
    )
  }

  getItems () {
    const endpoint = '/wp-json/wp/v2/search?&per_page=100'
    axios
      .get(`${endpoint}&search=${this.state.queryString}`)
      .then(response => {
        this.updateItems(response.data)
      })
      .catch(error => {
        console.log('SearchApp error', error)
      })
  }

  updateItems (items) {
    const lenders = items.filter(item => item.subtype === 'lg_lender')
    const pages = items.filter(item => item.subtype === 'page')
    const isOpen = lenders.length > 0 || pages.length > 0

    this.setState(
      {
        itemsLender: lenders,
        itemsPage: pages,
        isOpen: isOpen
      },
      () => {
        if (isOpen) {
          this.addEventListeners()
        } else {
          this.removeEventListeners()
        }
      }
    )
  }

  clearItems () {
    this.setState(
      {
        itemsLender: [],
        itemsPage: [],
        isOpen: false
      },
      this.removeEventListeners
    )
  }

  addEventListeners () {
    document.addEventListener('click', this.detectClickOutside)
  }

  removeEventListeners () {
    document.removeEventListener('click', this.detectClickOutside)
  }

  detectClickOutside (e) {
    if (
      e.target.classList.contains('Search__app') ||
      e.target.closest('.Search__app')
    ) {
      return false
    }

    this.setState(
      {
        queryString: ''
      },
      this.clearItems
    )
  }

  render () {
    return (
      <div className="Search__app">
        <label className="Search__label" htmlFor="Search__input">
          Sök
        </label>
        <input
          type="search"
          id="Search__input"
          className="Search__input"
          placeholder="Sök lån"
          value={this.state.queryString}
          onInput={this.inputHandler}
        />
        {this.state.isOpen && (
          <div className="Search__results">
            {this.state.itemsLender.length > 0 && (
              <div className="Search__result-category">
                <h3 className="Search__results-heading">Långivare</h3>
                <ul className="Search__results-items">
                  {this.state.itemsLender.map(item => (
                    <li className="Search__result-item" key={item.id}>
                      <a className="Search__result-link" href={item.url}>
                        <span className="Search__result-text">
                          {item.title}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {this.state.itemsPage.length > 0 && (
              <div className="Search__result-category">
                <h3 className="Search__results-heading">Sidor</h3>
                <ul className="Search__results-items">
                  {this.state.itemsPage.map(item => (
                    <li className="Search__result-item" key={item.id}>
                      <a className="Search__result-link" href={item.url}>
                        <span className="Search__result-text">
                          {item.title}
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

SearchApp.propTypes = {
  postType: PropTypes.string,
  lenderList: PropTypes.string,
  initAmount: PropTypes.number
}

export default SearchApp
